import React, { Component } from 'react';
import {AppBar, Toolbar, Typography, Paper, CardContent, TextField, CardActions, Button, CircularProgress, List, ListItem, ListItemIcon} from '@material-ui/core';

class OTPContainer extends Component {
    constructor() {
        super();
        this.state = {number: ""};
        fetch('https://559b8331.ngrok.io/otp', {method: 'POST'}).then(res => res.json()).then((res) => {console.log(res)});
    }

    setNumber(value) {this.setState({number: value})}
    render() {
        return <React.Fragment>
        <CardContent>
            <Typography variant="headline">Let's get started.</Typography>
            <div className="spacer"></div>
            We've sent a One-Time Pin to <strong>+44 7842 778167</strong>. Enter it below to continue.
            <div className="spacer"></div>
            <TextField label="PIN" />
            
        </CardContent>
        
        <CardActions>
            <Button variant="contained" color="primary" onClick={this.props.done}>Verify</Button>
        </CardActions>
        </React.Fragment>
    }
}

export default OTPContainer;